import { createReducer } from "@reduxjs/toolkit";

const StudentInitialState = {
    loading: false,
    Student: {},
    Students: [],
    error: {},
    Schedule: [],
    StatusInProgressStudents: [],
    StatusHoldStudents: [],
    StatusChanged: null,
    statusChangeSuccess: null,  // To track the success/failure of the status change
    PersonalNotificationData:"",
    UserPaymentMethodData:"",
    UserOpenDisputeData:"",
    InstituteInformation:"",
    InstituteAllCoursesInformation:"",
    InstituteTrainingStats:"",
    InstituteAddress:"",
    CourseName:"",
    FeedbackPagedata:"",
    VLIAgentsData:"",
    InstitutePackagesData:"",
    InstituteTrainingAndOfficeHours:"",
    InstituteOwnersProfileData:"",
    InstituteDetails:'',
    StudentDetails:'',
    StudentAllCoursesSchedule: [],
    InstituteAllStudentsSchedule:[],
};

export const StudentReducer = createReducer(StudentInitialState, (builder) => {
    builder.addCase("GetStudentsListRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetStudentsListSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Students = action.payload;
    });

    builder.addCase("GetStudentsListFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    //Student list Enrollment Status Inprogress
    builder.addCase("GetStatusInProgressStudentsListRequest", (state) => {
        state.loading = true;
    });

    builder.addCase(
        "GetStatusInProgressStudentsListSuccess",
        (state, action) => {
            state.loading = false;
            state.error = {};
            state.StatusInProgressStudents = action.payload;
        }
    );

    builder.addCase("GetStatusInProgressStudentsListError", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    //Students list course Enrollment status on Hold
    builder.addCase("GetStatusHoldStudentsListRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetStatusHoldStudentsListSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.StatusHoldStudents = action.payload;
    });

    builder.addCase("GetStatusHoldStudentsListError", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("GetAboutClientRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetAboutClientSuccess", (state, action) => {
        console.log("GetAboutClientSuccess State", state);
        console.log("GetAboutClientSuccess Action", action);

        state.loading = false;
        state.error = {};
        state.CourseProgress = action.CourseProgress;
        state.CoursePackage = action.CoursePackage;
        state.Student = action.Student;
        state.ScheduleTimeTable = action.ScheduleTimeTable;
        state.StudentInfo = action.StudentInfo;
    });

    builder.addCase("GetAboutClientFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("GetClassScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetClassScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Schedule = action.payload;
    });

    builder.addCase("GetClassScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("GetStudentAllCoursesClassScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetStudentAllCoursesClassScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.StudentAllCoursesSchedule = action.payload;
    });

    builder.addCase("GetStudentAllCoursesClassScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("CreateStudentClassesScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("CreateStudentClassesScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    });

    builder.addCase("CreateStudentClassesScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("CreateScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("CreateScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Schedule = action.payload;
    });

    builder.addCase("CreateScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("UpdateScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("UpdateScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Schedule = action.payload;
    });

    builder.addCase("UpdateScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    //
    builder.addCase("GetTimeTableRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetTimeTableSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Schedule = action.payload;
    });

    builder.addCase("GetTimeTableFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     //get Course name
     builder.addCase("GetCourseNameRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetCourseNameSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.CourseName = action.payload;
    });

    builder.addCase("GetCourseNameFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    builder.addCase("SubscriptionRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("SubscriptionSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Subscription = action.payload;
    });

    builder.addCase("SubscriptionFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    // New cases for fetching user by ID
    builder.addCase("GetUserByIdRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetUserByIdSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.Student = action.payload; // Set Student instead of User
    });

    builder.addCase("GetUserByIdFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });


    builder.addCase("ChangeScheduleStatusRequest", (state, action) => {
        state.loading = true;
        state.statusChangeSuccess = null;  // Reset to null when the request starts
    });
    
    builder.addCase("ChangeScheduleStatusSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.StatusChanged = action.payload;
        state.statusChangeSuccess = action.payload.success;  // Set to true when the status change succeeds
    });
    
    builder.addCase("ChangeScheduleStatusFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.statusChangeSuccess = false;  // Set to false when the status change fails
    });


    // New cases for UpdateSettingsFieldsRequest  
    builder.addCase("UpdateSettingsFieldsRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("UpdateSettingsFieldsSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    });

    builder.addCase("UpdateSettingsFieldsFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // New cases for GetStudentNotificationData 
     builder.addCase("GetStudentNotificationDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetStudentNotificationDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.PersonalNotificationData = action.payload;
    });

    builder.addCase("GetStudentNotificationDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    // New cases for GetStudentNotificationData 
    builder.addCase("UpdateStudentNotificationDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("UpdateStudentNotificationDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    });

    builder.addCase("UpdateStudentNotificationDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    // Get User Payment Methods Data 
    builder.addCase("GetUserPaymentMethodDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetUserPaymentMethodDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.UserPaymentMethodData = action.payload;
    });

    builder.addCase("GetUserPaymentMethodDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // GetSettingsOpenDisputeTable Data 
     builder.addCase("GetSettingsOpenDisputeDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetSettingsOpenDisputeDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.UserOpenDisputeData = action.payload;
    });

    builder.addCase("GetSettingsOpenDisputeDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    // get institute info from the database InstituteInformation
    builder.addCase("GetInstituteInformationRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetInstituteInformationSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteInformation = action.payload;
    });

    builder.addCase("GetInstituteInformationFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

    // get one institute all courses
    builder.addCase("GetOneInstituteAllCoursesDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetOneInstituteAllCoursesDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteAllCoursesInformation = action.payload;
    });

    builder.addCase("GetOneInstituteAllCoursesDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // get one institute Training Stats
     builder.addCase("GetOneInstituteTrainingStatsDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetOneInstituteTrainingStatsDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteTrainingStats = action.payload;
    });

    builder.addCase("GetOneInstituteTrainingStatsDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // get institute Address info from the database InstituteInformation
     builder.addCase("GetInstituteAddressInformationRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetInstituteAddressInformationSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteAddress = action.payload;
    });

    builder.addCase("GetInstituteAddressInformationFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // Get Feedback Page Data
     builder.addCase("GetFeedbackPageDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("GetFeedbackPageDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.FeedbackPagedata = action.payload;
    });

    builder.addCase("GetFeedbackPageDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

     // GetVLIAgentsA
     builder.addCase("GetVLIAgentsARequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("GetVLIAgentsASuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.VLIAgentsData = action.payload;
    })
    builder.addCase("GetVLIAgentsAError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // UpdateVLIAgentsA
    builder.addCase("UpdateVLIAgentsRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("UpdateVLIAgentsSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("UpdateVLIAgentsError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // GetInstitutePackagesDetails
    builder.addCase("GetInstitutePackagesDetailsRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("GetInstitutePackagesDetailsSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstitutePackagesData = action.payload;
    })
    builder.addCase("GetInstitutePackagesDetailsError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })


    // Update Feedback Page Data
    builder.addCase("UpdateFeedbackPageDataRequest", (state) => {
        state.loading = true;
    });

    builder.addCase("UpdateFeedbackPageDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    });

    builder.addCase("UpdateFeedbackPageDataFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });
    
    // UpdateInstituteTrainingAndOfficeHours
    builder.addCase("UpdateInstituteTrainingAndOfficeHoursRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("UpdateInstituteTrainingAndOfficeHoursSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("UpdateInstituteTrainingAndOfficeHoursError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // UpdateInstituteTrainingAndOfficeHours InstituteTrainingAndOfficeHours
    builder.addCase("FetchInstituteTrainingAndOfficeHoursRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchInstituteTrainingAndOfficeHoursSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteTrainingAndOfficeHours = action.payload;
    })
    builder.addCase("FetchInstituteTrainingAndOfficeHoursError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // FetchInstituteOwnersProfileData 
    builder.addCase("FetchInstituteOwnersProfileDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchInstituteOwnersProfileDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteOwnersProfileData = action.payload;
    })
    builder.addCase("FetchInstituteOwnersProfileDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // UpdateInstituteOwnersProfileData 
    builder.addCase("UpdateInstituteOwnersProfileDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("UpdateInstituteOwnersProfileDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
    })
    builder.addCase("UpdateInstituteOwnersProfileDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

    // FetchInstituteData 
    builder.addCase("FetchInstituteDataRequest", (state, action) => {
        state.loading = true;
    })
    builder.addCase("FetchInstituteDataSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteDetails = action.payload;
    })
    builder.addCase("FetchInstituteDataError", (state, action) => {
        state.loading = false;
        state.error = action.payload
    })

     //get GetStudentDetailsA
     builder.addCase("GetStudentDetailsRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetStudentDetailsSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.StudentDetails = action.payload;
    });

    builder.addCase("GetStudentDetailsFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });


    builder.addCase("GetInstituteAllStudentsScheduleRequest", (state, action) => {
        state.loading = true;
    });

    builder.addCase("GetInstituteAllStudentsScheduleSuccess", (state, action) => {
        state.loading = false;
        state.error = {};
        state.InstituteAllStudentsSchedule = action.payload;
    });

    builder.addCase("GetInstituteAllStudentsScheduleFailure", (state, action) => {
        state.loading = false;
        state.error = action.payload;
    });

});
